import { useTranslation } from 'react-i18next';

import { LeechList } from '@/features/leeches';

import styles from './HealthPage.module.css';

/** The cards of every deck that keep being forgotten. */
export function HealthPage(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <h1>{t('health.title')}</h1>
      <p className={styles.muted}>{t('health.explain')}</p>
      <LeechList />
    </div>
  );
}
